import type {FC} from 'react';
import React from 'react';

import {
	ContentBlockContainer,
	type ContentBlockContainerProps,
} from '@/modules/page/components/content-blocks/block-container';

import {Form} from '../form';

export const ContactFormSection: FC<ContentBlockContainerProps & {insideToc?: boolean}> = ({
	options,
	insideToc,
}) => {
	return (
		<ContentBlockContainer
			width={options?.fullWidth ? 'screen' : (options?.width ?? 'text')}
			options={options}
			insideToc={insideToc}
		>
			<Form />
		</ContentBlockContainer>
	);
};
